export default "__VITE_ASSET__3ba803ec__"